import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { PartnerDiscountCode, PartnerDiscountPercentage } from '@models/partner/client-setup/partner-client-setup';
import { AtlasToastService } from '@services/atlas-toast.service';
import { LoaderService } from '@services/loader.service';
import { PartnerClientSetUpService } from '@services/partner-clientsetup.service';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wsb-partner-clientsetup-discountcode',
  templateUrl: './partner-clientsetup-discountcode.component.html',
  styleUrls: ['./partner-clientsetup-discountcode.component.scss'],
  standalone: false
})
export class PartnerDiscountCodeComponent implements OnInit {
  listDiscountCodes = [];
  isShowBtnCreateDiscounCode = false;
  newDCodeControl: UntypedFormControl = new UntypedFormControl();

  constructor(
    private clientSetUpService: PartnerClientSetUpService,
    private atlasToast: AtlasToastService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.loaderService.show();
    this.clientSetUpService
      .getPromoCodes()
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(promos => {
        this.isShowBtnCreateDiscounCode = promos.data?.length > 0 ? false : true;
        this.listDiscountCodes = promos.data;
      });
  }

  addPromoCode() {
    this.newDCodeControl.disable();
    const newCode: string = this.newDCodeControl.value;
    if (_.isNull(newCode) || newCode.startsWith(' ')) {
      this.newDCodeControl.enable();
      return;
    }
    const newDiscountCode = this.buildPartnerDiscountCode(newCode);
    this.clientSetUpService.addPromoCode(newDiscountCode).subscribe(
      success => {
        this.successAddPromoCode(newDiscountCode);
      },
      error => {
        this.atlasToast.error('common_error', null, 6000);
        this.newDCodeControl.enable();
      }
    );
  }

  private successAddPromoCode(newDiscountCode) {
    this.isShowBtnCreateDiscounCode = false;
    this.listDiscountCodes.push(newDiscountCode);
    this.atlasToast.success('common_success', null, 6000);
    this.newDCodeControl.enable();
  }

  private buildPartnerDiscountCode(newCode: string) {
    const newCodeDiscount = new PartnerDiscountCode();
    newCodeDiscount.discountCode = newCode;
    newCodeDiscount.discountPerc = PartnerDiscountPercentage.PERC_FIVE;
    return newCodeDiscount;
  }
}
